import { EntityRecording, EntityRecordingEventType } from '../../../../types/entityRecordingTypes';
import Data from './data';
import Documents from './documents';
import Receivable from './receivable';
import Note from './note';

export type TimelineItemProps<T extends EntityRecordingEventType = EntityRecordingEventType> = {
  event: EntityRecording<T>
  editing?: boolean;
  cancelEditing?: () => void;
}
export default function TimelineItem({ event, editing, cancelEditing }: TimelineItemProps) {
  switch (event.eventType) {
    case "message_added":
    case "note_added": return <Note event={event} editing={editing} cancelEditing={cancelEditing} />;
    case "document_uploaded": return <Documents event={event} editing={editing} />;
    case "document_deleted": return <Documents event={event} editing={editing} />;
    case "case_updated": return <Data event={event} editing={editing} />;
    case "receivable_offer_published":
    case "receivable_offer_sent":
    case "receivable_offer_accepted":
    case "receivable_invoice_created":
    case "receivable_invoice_sent":
    case "receivable_invoice_paid": return <Receivable event={event} editing={editing} />;
    default: return null
  }
}
